<template>
  <transition name="fade" mode="out-in">
    <v-list-tile
      :key="range.index"
      ripple>
      <v-list-tile-action v-if="isAdmin">
        <v-btn icon ripple @click.stop="editRangeTable(range)">
          <span
            class="pl-ranges-icon"
            :style="{ backgroundColor: range.color}"
            :class="[ range.color, { 'pl-ranges-icon--selected': isSelected(range.id) } ]"></span>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-action v-else>
        <div class="v-btn v-btn--icon theme--light">
          <span
            class="pl-ranges-icon"
            :style="{ backgroundColor: range.color}"
            :class="range.color"></span>
        </div>
      </v-list-tile-action>

      <v-list-tile-content>
        <v-list-tile-title v-html="range.title"/>
        <v-list-tile-sub-title class="black--text pl-ranges-description" v-html="range.description"/>
        <v-list-tile-sub-title class="text-no-wrap">
          {{ getItemSumFrequecies }}% ({{ getItemSumCombos }} combos)
        </v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action v-if="isAdmin && !rangeEdit">
        <v-btn icon ripple @click.stop="editRange(range)">
          <v-icon color="grey lighten-1">edit</v-icon>
        </v-btn>
      </v-list-tile-action>

      <v-list-tile-action v-if="isAdmin && !rangeEdit">
        <v-btn icon ripple @click.stop="removeRange(range)">
          <v-icon color="grey lighten-1">delete</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { db } from '@/db'

export default {
  name: 'RangeListItem',

  props: {
    range: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters('auth', ['isAdmin']),
    ...mapGetters(['selectedRange', 'rangeEdit']),

    getItemSumCombos () {
      let sumCombos = this.range.hands.map(hand => (hand.combos * (hand.frequency / 100)))
        .reduce((a, b) => a + b, 0)
      return sumCombos.toFixed(2)
    },

    getItemSumFrequecies () {
      let frequecies = this.range.hands.map(hand => ((hand.combos * (hand.frequency / 100)) / 1326) * 100)
        .reduce((a, b) => a + b, 0)
      return frequecies.toFixed(2)
    }
  },

  methods: {
    ...mapActions(['toggleModal', 'toggleRange', 'setSelectedItem', 'setSelectedRange']),
    ...mapActions('ranges', ['getRanges']),

    isSelected (id) {
      return id === this.selectedRange.id
    },

    editRange (range) {
      const editedItem = { id: range.id, ...range }
      this.setSelectedItem(editedItem)
      this.toggleModal()
    },

    editRangeTable (range) {
      if (this.rangeEdit) {
        this.save(this.selectedRange)
      } else {
        this.setSelectedRange(range)
        this.toggleRange()
      }
    },

    removeRange (range) {
      this.$root.$confirm({
        title: 'Excluir Range'
      }).then((confirm) => {
        if (confirm) {
          let currentDocRef = db.collection('ranges').doc(range.id)

          currentDocRef.delete().then((success) => {
            console.log('Range deleted!')
          }).catch((error) => {
            console.error('Error removing document: ', error)
          })
        }
      })
    },

    save (rangeObj) {
      let _this = this

      const updatedAt = new Date()
      let currentDocRef = db.collection('ranges').doc(rangeObj.id)

      currentDocRef.set({
        ...rangeObj,
        updatedAt
      }).then(() => {
        _this.toggleRange()
        _this.setSelectedRange({
          title: '',
          description: '',
          color: 'gray',
          hands: []
        })
      })
    }
  }
}
</script>
